export const model = {
    id: null,
    name: '',   
    city_id: '', 
    code: "",
    created_at: '',
    updated_at: ''
};
